import { cn } from "@/lib/utils";
import outlawsLogo from "@/assets/outlaws-logo.webp";

interface LogoProps {
  className?: string;
  size?: "sm" | "md" | "lg";
}

export const Logo = ({ className, size = "md" }: LogoProps) => {
  const sizeClasses = {
    sm: "h-8",
    md: "h-14",
    lg: "h-24",
    xl: "h-32"
  };

  return (
    <img
      src={outlawsLogo}
      alt="ØUTLAWS"
      className={cn(sizeClasses[size], "w-auto", className)}
    />
  );
};